import { InitPagedData } from "./../Utils";
import {
  MaterialMajorCategoryStateTypes,
  MaterialMajorCategoryActionTypes,
} from "./MaterialMajorCategory.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialMajorCategoryStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchAllForm: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchPaged: resetApiCallState(InitPagedData),
};

const MaterialMajorCategoryReducer = (
  state: MaterialMajorCategoryStateTypes = INITIAL_STATE,
  action: any
): MaterialMajorCategoryStateTypes => {
  switch (action.type) {
    case MaterialMajorCategoryActionTypes.FETCH_ALL_MATERIAL_MAJOR_CATEGORY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialMajorCategoryActionTypes.FETCH_ALL_MATERIAL_MAJOR_CATEGORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialMajorCategoryActionTypes.FETCH_ALL_MATERIAL_MAJOR_CATEGORY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialMajorCategoryActionTypes.FETCH_ALL_MATERIAL_MAJOR_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------------------------

    case MaterialMajorCategoryActionTypes.FETCH_ALL_FORM_MATERIAL_MAJOR_CATEGORY:
      return {
        ...state,
        fetchAllForm: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialMajorCategoryActionTypes.FETCH_ALL_FORM_MATERIAL_MAJOR_CATEGORY_RESET:
      return {
        ...state,
        fetchAllForm: resetApiCallState([]),
      };
    case MaterialMajorCategoryActionTypes.FETCH_ALL_FORM_MATERIAL_MAJOR_CATEGORY_FAILURE:
      return {
        ...state,
        fetchAllForm: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialMajorCategoryActionTypes.FETCH_ALL_FORM_MATERIAL_MAJOR_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchAllForm: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------------------------

    case MaterialMajorCategoryActionTypes.FETCH_PAGED_MATERIAL_MAJOR_CATEGORY:
      return {
        ...state,
        fetchPaged: {
          error: null,
          payload: InitPagedData,
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialMajorCategoryActionTypes.FETCH_PAGED_MATERIAL_MAJOR_CATEGORY_RESET:
      return {
        ...state,
        fetchPaged: resetApiCallState(InitPagedData),
      };
    case MaterialMajorCategoryActionTypes.FETCH_PAGED_MATERIAL_MAJOR_CATEGORY_FAILURE:
      return {
        ...state,
        fetchPaged: {
          payload: InitPagedData,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialMajorCategoryActionTypes.FETCH_PAGED_MATERIAL_MAJOR_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchPaged: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MaterialMajorCategoryActionTypes.FETCH_ONE_MATERIAL_MAJOR_CATEGORY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialMajorCategoryActionTypes.FETCH_ONE_MATERIAL_MAJOR_CATEGORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialMajorCategoryActionTypes.FETCH_ONE_MATERIAL_MAJOR_CATEGORY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialMajorCategoryActionTypes.FETCH_ONE_MATERIAL_MAJOR_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialMajorCategoryReducer;
